import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/defaultImage.png'


const _withScopeId = n => (_pushScopeId("data-v-378d1488"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ion-padding-horizontal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Silhouette of mountains",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "item-grid" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Silhouette of mountains",
  src: _imports_0
}, null, -1))
const _hoisted_6 = { class: "item-grid-loop" }
const _hoisted_7 = { class: "ion-padding-horizontal" }
const _hoisted_8 = { class: "ion-padding-horizontal" }
const _hoisted_9 = { class: "netsuite-mapping-grid" }
const _hoisted_10 = { class: "netsuite-mapping-grid" }
const _hoisted_11 = {
  key: 1,
  class: "user-profile"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "find" }
const _hoisted_14 = { class: "section-header ion-text-center" }
const _hoisted_15 = { class: "section-header ion-text-center" }

import {
  alertController,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonChip,
  IonContent,
  IonBadge,
  IonHeader,
  IonIcon,
  IonItem,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonLabel,
  IonList,
  IonNote,
  IonPage,
  IonSegment,
  IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonThumbnail,
  IonToolbar,
  IonSearchbar,
  modalController,
  onIonViewDidEnter
} from "@ionic/vue";

import { computed, nextTick, ref } from "vue";
import { useStore } from "@/store";
import { copyToClipboard, showToast } from "@/utils";
import { addOutline, openOutline, pencilOutline, trashOutline } from "ionicons/icons";
import NetSuiteModal from "@/components/NetSuiteModal.vue";
import LoopModal from "@/components/LoopModal.vue";
import { translate } from '@/i18n';
import NetSuiteMappingModal from "@/components/NetSuiteMappingModal.vue";
import UpdateUserLoginModal from "@/components/UpdateUserLoginModal.vue";
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";
import ReturnStatusModal from "@/components/ReturnStatusModal.vue";
import { hasError } from "@hotwax/oms-api";
import logger from "@/logger";
import { UserService } from "@/services/UserService";
import { IonInfiniteScrollCustomEvent } from "@ionic/core";
import emitter from "@/event-bus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const segmentSelected = ref('configuration');
const nsCredentialsList = ref([]);
const loopCredentialsList = ref([]);
const loopWebhookVerified = ref([]);
const netSuiteMapping = ref([]);
const searchQuery = ref('');
const returnStatusList = ref([]);
const returnCount = ref({});
const returnTotalCount = ref(0);
const currentStatus = ref("ALL");
const pageIndex = ref(0);
const loadMore = ref(true);
const loginKeyMap = ref({});
const selectedNSAccount = ref('');

const organizationDetails = computed(() => store.getters['user/getUserProfile']);

onIonViewDidEnter(async () => {
  await nextTick();
  emitter.emit("presentLoader", { message: "loading..." });
  await getVerifyLoopWebhook();
  await fetchUserNetSuiteDetails();
  await fetchUserLoopDetails();
  await getNetSuiteRMAMapping();
  await getAPIKey();
  await fetchUserProfile();
  emitter.emit("dismissLoader");
})

const segmentChanged = async(event: any) => {
  segmentSelected.value = event.detail.value;
  if (segmentSelected.value === 'dashboard') {
    await changeAccountType();
  } 
};

async function openNetsuiteModal(accountType: string ) {
  const modal = await modalController.create({
    component: NetSuiteModal,
    componentProps: { accountType },
  });
  modal.present();
  const { data, role } = await modal.onWillDismiss();
  if (role === 'save') {
    emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
    const response = await store.dispatch('user/netSuiteCredentials', data);
    if (response) {
      await fetchUserNetSuiteDetails()
      showToast(translate("NetSuite credentials saved successfully."));
    }
    emitter.emit("dismissLoader")
  }
}

async function openNetSuiteMappingModal(accountType: string , systemMessageRemoteId: string) {
  
  const modal = await modalController.create({
    component: NetSuiteMappingModal,
    componentProps: { accountType, systemMessageRemoteId },
  });
  modal.present();
  const { data, role } = await modal.onWillDismiss();
  if (role === 'save') {
    emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
    const response = await store.dispatch('user/netsuiteMapping', data);
    if (response) {
      await getNetSuiteRMAMapping()
      showToast(response.messages);
    }
    emitter.emit("dismissLoader")
  }
} 

async function getNetSuiteRMAMapping() {
  const response = await store.dispatch('user/getNetSuiteRMAMapping');
  if (response) {
    netSuiteMapping.value = response.integrationTypeMappingMap
  }
}

async function openLoopModal(accountType: string ) {
  const modal = await modalController.create({
    component: LoopModal,
    componentProps: { accountType },
  });
  modal.present();
  const { data, role } = await modal.onWillDismiss();
  if (role === 'save') {
    emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
    const response = await store.dispatch('user/loopCredentials', data);
    if (response) {
      await fetchUserLoopDetails()
      showToast(translate("Loop credentials saved successfully."));
    }
    emitter.emit("dismissLoader")
  }
}

async function fetchUserProfile() {
  await store.dispatch('user/getProfile');
}

async function fetchUserNetSuiteDetails() {
  const response = await store.dispatch('user/getNetSuiteDetails');
  if (response) {
    nsCredentialsList.value = response.netsuiteRemoteList;
  } 
  // set default selected account to sandbox if exists, otherwise first entry
  if (nsCredentialsList.value?.length) {
    const sandbox = nsCredentialsList.value.find((nsCredential: any) => nsCredential.accountType === 'sandbox');
    selectedNSAccount.value = sandbox?.systemMessageRemoteId || nsCredentialsList.value[0].systemMessageRemoteId;
  }
}

async function deleteNetsuiteCredential(data: any) {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  const response = await store.dispatch('user/deleteNetSuiteCredential', data);
  if (response) {
    nsCredentialsList.value = nsCredentialsList.value.filter(cred => cred.systemMessageRemoteId !== data.systemMessageRemoteId);
    showToast(translate("NetSuite credential deleted successfully."));
  }
  emitter.emit("dismissLoader");
}

const isChipDisabled = (type: string, cardType : string) => {
  if (cardType === 'NetSuite') {
    return nsCredentialsList?.value?.some(cred => cred.accountType === type);
  } else if (cardType === 'Loop') {
    return loopCredentialsList?.value?.some(cred => cred.accountType === type);
  }
}; 

async function fetchUserLoopDetails() {
  const response = await store.dispatch('user/getLoopDetails');
  if (response) {
    loopCredentialsList.value = response.loopRemoteList;
  } 
}

async function deleteLoopCredential(data: any) {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  const response = await store.dispatch('user/deleteLoopCredential', data);
  if (response) {
    loopCredentialsList.value = loopCredentialsList.value.filter(cred => cred.systemMessageRemoteId !== data.systemMessageRemoteId);
    showToast(translate("Loop credential deleted successfully."));
  }
  emitter.emit("dismissLoader");
}

async function deleteLoopWebHook(data: any) {
  try {
    emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
    const response = await UserService.deleteLoopWebHook(data);
    if (!hasError(response)) {
      await fetchUserLoopDetails()
      showToast(translate("Loop Webhook Unscrible successfully."));
    } else {
      throw response.data
    }
    emitter.emit("dismissLoader")
  } catch (err) {
    logger.error(err)
    emitter.emit("dismissLoader");
    showToast(translate("Failed to Unscrible Loop webhook."));
  }
}

async function verifyNetsuiteCredential(systemMessageRemoteId: string) {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  const response = await store.dispatch('user/verifyNetsuiteCredential', systemMessageRemoteId);
  if (response) {
    await fetchUserNetSuiteDetails()
    showToast(translate("Verified NetSuite Credentials successfully."));
  }  
  emitter.emit("dismissLoader")
}

async function syncNetsuiteMapping(systemMessageRemoteId: string) {
  emitter.emit("presentLoader", { message: "Syncing...", backdropDismiss: false });
  const response = await store.dispatch('user/syncNetsuiteMapping', systemMessageRemoteId);
  if (response) {
    await getNetSuiteRMAMapping()
    showToast(translate("NetSuite mapping synced successfully."));
  } 
  emitter.emit("dismissLoader");
}

async function syncAllNetsuiteMapping(systemMessageRemoteId: string) {
  try {
    emitter.emit("presentLoader", { message: "Syncing...", backdropDismiss: false });
    const response = await UserService.syncAllNetsuiteMapping(systemMessageRemoteId);
    if (response) {
      await getNetSuiteRMAMapping()
      showToast(translate("NetSuite mapping synced successfully."));
    }
    emitter.emit("dismissLoader");
  } catch (error) {
    logger.error(error)
    emitter.emit("dismissLoader");
    showToast(translate("Unable to sync NetSuite mapping. Please try again."));
  } 
}

async function deleteIntegrationTypeMappings(payload: any) {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  const response = await store.dispatch('user/deleteIntegrationTypeMappings', payload);
  if (response) {
    getNetSuiteRMAMapping()
    showToast(translate("NetSuite mapping deleted successfully."));
  } 
  emitter.emit("dismissLoader");
}

async function updateIntegrationTypeMapping(mapping: any) {
  
  const alert = await alertController.create({
    header: translate('Enter Mapping Value'),
    inputs: [
      {
        name: 'mappingValue',
        type: 'number',
        placeholder: translate('Mapping value')
      }
    ],
    buttons: [
      {
        text: translate('Cancel'),
        role: 'cancel'
      },
      {
        text: translate('Save'),
        handler: async (data) => {
          if (!data.mappingValue.trim()) {
            showToast(translate("Please provide a value."));
            return false;
          }
          const payload = { 
            integrationMappingId: mapping.integrationMappingId,
            mappingValue: data.mappingValue 
          };
          try {
            emitter.emit("presentLoader", { message: "Updating...", backdropDismiss: false });
            const response = await UserService.updateIntegrationTypeMapping(payload);
            if (!hasError(response)) {
              await getNetSuiteRMAMapping()
              showToast(translate("NetSuite mapping updated successfully."));
            } else {
              throw response.data
            }
            emitter.emit("dismissLoader");
          } catch (err) {
            logger.error(err)
            emitter.emit("dismissLoader");
            showToast(translate("Failed to update NetSuite mapping."));
          }
        }
      }
    ]
  });
  await alert.present();
}

async function verifyloopCredential(loopCredentials: any) {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  const response = await store.dispatch('user/verifyloopCredential', loopCredentials);
  if (response) {
    await fetchUserLoopDetails()
    showToast(translate("Verified Loop Credentials successfully."));
  }
  emitter.emit("dismissLoader")
}

async function getVerifyLoopWebhook() {
  const response = await store.dispatch('user/getVerifyLoopWebhook');
  if (response) {
    loopWebhookVerified.value = response
  }
}

async function getAPIKey() {
  try {
    const response = await UserService.getAPIKey();
    if (response) {
      loginKeyMap.value = response.data.loginKeyMap;
    }
  } catch (error) {
    logger.error(error)
    showToast(translate("Failed to get apiKey."));
  }
}

async function postAPIKey(credentials: any) {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  const response = await store.dispatch('user/postAPIKey', credentials);
  emitter.emit("dismissLoader")
  if (response) {
    const alert = await alertController.create({
      header: translate('Refresh API Key'),
      message: `
        An API Key has been generated for NetSuite Account ID <b>${credentials.remoteId}</b>.<br/><br/>
        Please copy and save this key now — it will only be shown once.<br/>
        Use this key to create an API Secret record in NetSuite.<br/><br/>
        <b>Your API Key is:</b> ${response.loginKey}
      `,
      buttons: [
        {
          text: translate('copy API Key'),
          role: 'copy',
          handler: () => copyToClipboard(response?.loginKey)
        },
      ]
    });
    getAPIKey()
    await alert.present();
  } else {
    emitter.emit("dismissLoader")
    showToast(translate("Unable to get NetSuite apiKey. Please try again."));
  }
}

async function updateProfile(profile: any ) {
  
  const modal = await modalController.create({
    component: UpdateUserLoginModal,
    componentProps: { profile },
  });
  modal.present();
  const { data, role } = await modal.onWillDismiss();
  if (role === 'save') {
    try {
      emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
      const response = await UserService.updateUserProfile(data)
      if (!hasError(response)) {
        await fetchUserProfile()
        showToast(translate("User profile updated successfully."));
      } else {
        throw response.data
      }
      emitter.emit("dismissLoader");
    } catch (err) {
      logger.error(err)
      emitter.emit("dismissLoader");
      showToast(translate("Failed to update user profile."));
    }
  }
} 

async function updatePassword(profile: any ) {
  
  const modal = await modalController.create({
    component: ChangePasswordModal,
    componentProps: { profile },
  });
  modal.present();
  const { data, role } = await modal.onWillDismiss();
  if (role === 'save') {
    try {
      emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
      const resp = await UserService.updatePassword(data)
      if (!hasError(resp)) {
        showToast(translate("New password updated successfully."));
      } else {
        throw resp.data
      }
      emitter.emit("dismissLoader");
    } catch (err) {
      logger.error(err)
      emitter.emit("dismissLoader");
      showToast(translate("Failed to update password."));
    }
  }
}

async function openReturnStatusModal(returnMap: any) {
  try {
    emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
    const response = await UserService.getLoopReturnStatusDetails(returnMap.loopReturnId);
    emitter.emit("dismissLoader");
    if (!hasError(response)) {
      const modal = await modalController.create({
        component: ReturnStatusModal,
        componentProps: { response: response.data, returnMap },
      });
      modal.present();
      await modal.onWillDismiss();
    } else {
      throw response.data
    }
  } catch (error) {
    logger.error(error)
    emitter.emit("dismissLoader");
    showToast(translate("Failed to get Loop return details."));
  }
}

async function getLoopReturnStatusCount(systemMessageRemoteId: string) {
  try {
      const response = await UserService.getLoopReturnStatusCount(systemMessageRemoteId)
      if (!hasError(response)) {
        returnCount.value = response.data.returnCountMap
        returnTotalCount.value = response.data.returnCountMap.open + response.data.returnCountMap.closed + response.data.returnCountMap.failed
      } else {
        throw response.data
      }
    } catch (err) {
      logger.error(err)
      showToast(translate("Failed to fetch return count."));
    }
}

async function getLoopReturnStatusList(statusId: string, reset = true ,pageSize = 50) {
  try {
    if (reset) {
      pageIndex.value = 0;
      loadMore.value = true;
      currentStatus.value = statusId;
      emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
    }

    const params: any = { pageIndex: pageIndex.value, pageSize };
    if (statusId && statusId !== "ALL") {
      params.statusId = statusId;
    }
     // include selected NetSuite account if chosen
    if (selectedNSAccount.value) {
      params.systemMessageRemoteId = selectedNSAccount.value;
    }

    const response = await UserService.getLoopReturnStatusList(params);
    if (!hasError(response)) {
      const data = response.data?.returnList || [];
      if (data.length < pageSize) loadMore.value = false;
      returnStatusList.value = reset ? data : [...returnStatusList.value, ...data];
    } else {
      throw response.data;
    }
  } catch (err) {
    logger.error(err);
    showToast(translate("Failed to fetch return list."));
  } finally {
    if (reset) emitter.emit("dismissLoader");
  }
}

async function loadMoreReturns(ev: IonInfiniteScrollCustomEvent<void>) {
  if (!loadMore.value) {
    ev.target.complete();
    return;
  }
  pageIndex.value++;
  await getLoopReturnStatusList(currentStatus.value, false);
  ev.target.complete();
}

const confirmDelete = async (onConfirm: any, message?: string) => {
  const alert = await alertController.create({
      subHeader:  message ? message : translate('Do you really want to delete?'),
      buttons: [
        {
          text: translate('Cancel'),
          role: 'cancel'
        },
        {
          text: translate('Ok'),
          handler: onConfirm
        }
      ]
    });
    await alert.present();
}

const changeAccountType = async () => {
  emitter.emit("presentLoader", { message: "Loading...", backdropDismiss: false });
  await getLoopReturnStatusCount(selectedNSAccount.value);
  await getLoopReturnStatusList("ALL");
  emitter.emit("dismissLoader");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), {
                lines: "none",
                slot: "start"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_unref(organizationDetails)?.organizationName), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegment), {
                modelValue: segmentSelected.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((segmentSelected).value = $event)),
                onIonChange: segmentChanged
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonSegmentButton), { value: "configuration" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Configuration")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "account" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Account")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonSegmentButton), { value: "dashboard" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Dashboard")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), {
        ref: "contentRef",
        "scroll-events": true
      }, {
        default: _withCtx(() => [
          (segmentSelected.value === 'configuration')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(IonCard), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonThumbnail), { slot: "start" }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonCardTitle), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(translate)("NetSuite Credentials")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonChip), {
                                  disabled: isChipDisabled('sandbox' , 'NetSuite'),
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openNetsuiteModal('sandbox'))),
                                  outline: true
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("sandbox")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]),
                                _createVNode(_unref(IonChip), {
                                  disabled: isChipDisabled('production', 'NetSuite'),
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (openNetsuiteModal('production'))),
                                  outline: true
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("production")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonList), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nsCredentialsList.value, (credentials, index) => {
                              return (_openBlock(), _createBlock(_unref(IonItem), {
                                key: index,
                                lines: index === nsCredentialsList.value.length - 1 ? 'none' : ''
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)(credentials.accountType)) + " ", 1),
                                        _createElementVNode("p", null, _toDisplayString(credentials.remoteId), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_unref(IonButton), {
                                      class: "ion-text-center ion-text-nowrap",
                                      fill: "outline",
                                      size: "small",
                                      onClick: ($event: any) => (postAPIKey(credentials))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)(credentials.systemMessageRemoteId in loginKeyMap.value ? "Refresh API Key" : "Generate API Key")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    (credentials.verified === 'Y')
                                      ? (_openBlock(), _createBlock(_unref(IonNote), {
                                          key: 0,
                                          class: "ion-text-center",
                                          color: "success"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(translate)("Verified")), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (credentials.verified === 'N')
                                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                                            key: 1,
                                            class: "ion-text-center",
                                            color: "warning",
                                            fill: "outline",
                                            size: "small",
                                            onClick: ($event: any) => (verifyNetsuiteCredential(credentials.systemMessageRemoteId))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(translate)("Verify")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_unref(IonButton), {
                                      size: "default",
                                      fill: "clear",
                                      color: "medium",
                                      onClick: ($event: any) => (confirmDelete(() => deleteNetsuiteCredential(credentials)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonIcon), {
                                          slot: "icon-only",
                                          icon: _unref(trashOutline)
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["lines"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_unref(IonCard), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonThumbnail), { slot: "start" }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(IonCardTitle), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(translate)("Loop Credentials")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonChip), {
                                  disabled: isChipDisabled('sandbox', 'Loop'),
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openLoopModal('sandbox'))),
                                  outline: true
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("sandbox")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"]),
                                _createVNode(_unref(IonChip), {
                                  disabled: isChipDisabled('production','Loop'),
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openLoopModal('production'))),
                                  outline: true
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)("production")), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonList), null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loopCredentialsList.value, (loopCredentials, index) => {
                              return (_openBlock(), _createBlock(_unref(IonItem), {
                                key: index,
                                lines: index === loopCredentialsList.value.length - 1 ? 'none' : ''
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(translate)(loopCredentials.accountType)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (loopCredentials.verified === 'Y')
                                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                                          key: 0,
                                          class: "ion-text-center",
                                          color: "warning",
                                          fill: "outline",
                                          size: "small",
                                          onClick: ($event: any) => (confirmDelete(() => deleteLoopWebHook(loopCredentials),_unref(translate)('Do you want to unsubscribe Loop webhook?')))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(translate)("Unsubscribe")), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : (loopCredentials.verified === 'N')
                                        ? (_openBlock(), _createBlock(_unref(IonButton), {
                                            key: 1,
                                            class: "ion-text-center",
                                            disabled: loopWebhookVerified.value.webhookSubscriptionMap[loopCredentials.systemMessageRemoteId] == 'Y' ? false : true,
                                            color: "warning",
                                            fill: "outline",
                                            size: "small",
                                            onClick: ($event: any) => (verifyloopCredential(loopCredentials))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(translate)("Subscribe")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["disabled", "onClick"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_unref(IonButton), {
                                      fill: "clear",
                                      size: "default",
                                      color: "medium",
                                      onClick: ($event: any) => (confirmDelete(() => deleteLoopCredential(loopCredentials)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(IonIcon), {
                                          slot: "icon-only",
                                          icon: _unref(trashOutline)
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["lines"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("section", _hoisted_7, [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(IonCard), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardHeader), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), { lines: "none" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonCardTitle), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(translate)("NetSuite Integration Mapping")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonItem), { lines: "none" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nsCredentialsList.value, (credentials, index) => {
                                  return (_openBlock(), _createBlock(_unref(IonChip), {
                                    key: index,
                                    onClick: ($event: any) => (openNetSuiteMappingModal(credentials.accountType, credentials.systemMessageRemoteId)),
                                    outline: true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(IonIcon), { icon: _unref(addOutline) }, null, 8, ["icon"]),
                                      _createVNode(_unref(IonLabel), null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(translate)(credentials.accountType)), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("section", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nsCredentialsList.value, (credentials, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(_unref(IonCard), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonCardHeader), null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonItem), { lines: "none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonLabel), null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(translate)(`NetSuite ${credentials.accountType} Mapping`)) + " ", 1),
                                      _createElementVNode("p", null, _toDisplayString(credentials.remoteId), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_unref(IonButton), {
                                    slot: "end",
                                    fill: "outline",
                                    disabled: netSuiteMapping.value[credentials.systemMessageRemoteId]?.[0]?.scriptEndPoint != 'Y',
                                    onClick: ($event: any) => (syncAllNetsuiteMapping(credentials.systemMessageRemoteId))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(translate)('Sync All')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["disabled", "onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (netSuiteMapping.value[credentials.systemMessageRemoteId] && netSuiteMapping.value[credentials.systemMessageRemoteId].length > 0)
                            ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonItem), null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_unref(IonLabel), null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(translate)("Name")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonLabel), { class: "ion-text-center" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(translate)("Value")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonLabel), { class: "ion-text-center" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(translate)("Status")), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(IonLabel), { class: "ion-text-center" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(translate)("Action")), 1)
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(netSuiteMapping.value[credentials.systemMessageRemoteId], (mapping, index) => {
                                    return (_openBlock(), _createBlock(_unref(IonItem), {
                                      key: index,
                                      lines: index === netSuiteMapping.value[credentials.systemMessageRemoteId].length - 1 ? 'none' : ''
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_unref(IonLabel), null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(mapping.description), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_unref(IonLabel), { class: "ion-text-center" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(mapping.mappingValue), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          (mapping.synced == 'Y')
                                            ? (_openBlock(), _createBlock(_unref(IonNote), {
                                                key: 0,
                                                class: "ion-text-center",
                                                color: "success"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(translate)("Synced")), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (mapping.synced == 'N')
                                              ? (_openBlock(), _createBlock(_unref(IonButton), {
                                                  key: 1,
                                                  class: "ion-text-center",
                                                  color: "warning",
                                                  fill: "outline",
                                                  size: "small",
                                                  disabled: mapping.scriptEndPoint != 'Y',
                                                  onClick: ($event: any) => (syncNetsuiteMapping(mapping.integrationMappingId))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(translate)("Sync")), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled", "onClick"]))
                                              : _createCommentVNode("", true),
                                          _createVNode(_unref(IonButton), {
                                            fill: "clear",
                                            size: "default",
                                            color: "medium",
                                            onClick: ($event: any) => (confirmDelete(() => deleteIntegrationTypeMappings(mapping)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonIcon), {
                                                slot: "icon-only",
                                                icon: _unref(trashOutline)
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_unref(IonButton), {
                                            fill: "clear",
                                            size: "default",
                                            color: "medium",
                                            onClick: ($event: any) => (updateIntegrationTypeMapping(mapping))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(IonIcon), {
                                                slot: "icon-only",
                                                icon: _unref(pencilOutline)
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["lines"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (segmentSelected.value === 'account')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_unref(IonCard), { class: "ion-card-width" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardTitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(translate)("User Account Information")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCardSubtitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(organizationDetails)?.organizationName), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonList), { lines: "full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("User Id")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(organizationDetails)?.userId), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Full Name")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(organizationDetails)?.userFullName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Email")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(organizationDetails)?.emailAddress), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("User Name")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(organizationDetails)?.username), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Organization Name")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonLabel), { slot: "end" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(organizationDetails)?.organizationName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonButton), {
                              slot: "end",
                              color: "warning",
                              fill: "outline",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (updatePassword(_unref(organizationDetails))))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Change Password")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonButton), {
                              slot: "end",
                              fill: "outline",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (updateProfile(_unref(organizationDetails))))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Update Profile")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (segmentSelected.value === 'dashboard')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("aside", null, [
                    _createVNode(_unref(IonList), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonItem), { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSelect), {
                              label: _unref(translate)('Account Type'),
                              interface: "popover",
                              modelValue: selectedNSAccount.value,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedNSAccount).value = $event)),
                              onIonChange: changeAccountType
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nsCredentialsList.value, (ns) => {
                                  return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                                    key: ns.systemMessageRemoteId,
                                    value: ns.systemMessageRemoteId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(translate)(ns.accountType)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["label", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSearchbar), {
                              modelValue: searchQuery.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((searchQuery).value = $event)),
                              placeholder: _unref(translate)('Search Return'),
                              onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (searchQuery.value = $event.target.value), ["enter"]))
                            }, null, 8, ["modelValue", "placeholder"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), {
                          button: "",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (getLoopReturnStatusList('ALL')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("All Returns")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonChip), {
                              slot: "end",
                              outline: "true",
                              color: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(returnTotalCount.value), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), {
                          button: "",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (getLoopReturnStatusList('RT_OPEN')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Open")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonChip), {
                              slot: "end",
                              outline: "true",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(returnCount.value.open), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), {
                          button: "",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (getLoopReturnStatusList('RT_REFUNDED')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Closed")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonChip), {
                              slot: "end",
                              outline: "true",
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(returnCount.value.closed), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonItem), {
                          button: "",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (getLoopReturnStatusList('RT_ERROR')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)("Failed")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(IonChip), {
                              slot: "end",
                              outline: "true",
                              color: "danger"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(returnCount.value.failed), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("main", null, [
                    _createVNode(_unref(IonItem), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Loop Return Id")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Shopify Order Id")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Shopify Order Name")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)("NetSuite Return Id")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)("Status")), 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(translate)("History")), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(returnStatusList.value, (item, i) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        key: i,
                        class: "list-item"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.loopReturnId), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.shopifyOrderId), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.shopifyOrderName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.netsuiteReturnId), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("div", null, [
                              _createVNode(_unref(IonBadge), {
                                color: item.status === 'Refunded' ? 'success' : item.status === 'Error' ? 'danger' : ''
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.status), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _createVNode(_unref(IonButton), {
                              fill: "clear",
                              size: "default",
                              onClick: ($event: any) => (openReturnStatusModal(item))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "icon-only",
                                  icon: _unref(openOutline)
                                }, null, 8, ["icon"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_unref(IonInfiniteScroll), {
            onIonInfinite: _cache[14] || (_cache[14] = ($event: any) => (loadMoreReturns($event))),
            threshold: "100px",
            ref: "infiniteScrollRef"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonInfiniteScrollContent), {
                "loading-spinner": "crescent",
                "loading-text": _unref(translate)('Loading')
              }, null, 8, ["loading-text"])
            ]),
            _: 1
          }, 512), [
            [_vShow, (segmentSelected.value === 'dashboard')]
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}
}

})